var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.75 24.766a.767.767 0 0 1-.766-.766.767.767 0 0 1 1.533 0 .768.768 0 0 1-.767.766zm-1.134-9.723v6.148a3.034 3.034 0 0 0-1.9 2.809 3.037 3.037 0 0 0 3.034 3.034c.42 0 .822-.087 1.187-.243l2.81 2.809 1.604-1.604-2.81-2.809A3.01 3.01 0 0 0 28.784 24a3.033 3.033 0 0 0-1.9-2.809v-6.148h-2.268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.75 3.866c-10.49 0-19.122 8.067-20.042 18.322l-4.045-3.67-1.523 1.68 6.816 6.184 6.808-6.193-1.526-1.678L7.965 22.4c.813-9.103 8.473-16.265 17.785-16.265 9.852 0 17.866 8.014 17.866 17.866 0 9.851-8.014 17.866-17.866 17.866-6.314 0-12.224-3.387-15.422-8.84l-1.955 1.148c3.604 6.143 10.262 9.96 17.377 9.96 11.102 0 20.134-9.032 20.134-20.134S36.852 3.866 25.75 3.866"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.f7f70fc7b7e003a519925d9e1ba2f3a8.svg";
export { ForwardRef as ReactComponent };